import { PageHeader, SubNav } from '@/components/ui/page';
import { useAssistant } from '@/features/assistant/use-assistant';

/** Settings (TG-6, OUT-1, CAS-2): one header, and the tabs between its pages. */
const SettingsHeader = () => {
  const assistant = useAssistant();
  return (
    <PageHeader title="Settings" description="Who can sign in, the Telegram bot, outbound channels and the Owner Hub sync.">
      <SubNav
        label="Settings"
        items={[
          { to: '/settings/staff', label: 'Staff' },
          { to: '/settings/telegram', label: 'Telegram bot' },
          { to: '/settings/channels', label: 'Channels' },
          { to: '/settings/sync', label: 'Owner Hub sync' },
          // Assistant (ASSIST-1) only where it is on.
          ...(assistant.data?.enabled ? [{ to: '/settings/assistant', label: 'Assistant' }] : []),
        ]}
      />
    </PageHeader>
  );
};

export default SettingsHeader;
